import { ItemInfo } from '@/entities/OrderInfo';
import { AccountInfo, DeviceInfo } from '@/entities/base';
import { TOKEN_TYPE_MAP } from '@/entities/config';
import { aegis, aegisReportRetError } from '@/modules/aegis';
import { parseItemInfo, query } from '@/modules/util';
import { useAuth } from '@/store/auth';
import { authSend } from '@tencent/qb-auth-send-h5';
import { Camelized, camelizeKeys } from 'humps';

const itemInfoStr = query('item_info');
export let goodsItemInfo: ItemInfo;

try {
  goodsItemInfo = camelizeKeys(JSON.parse(decodeURIComponent(itemInfoStr) || '{}')) as ItemInfo;
} catch (error) {
  try {
    goodsItemInfo = camelizeKeys(JSON.parse(parseItemInfo() || '{}')) as ItemInfo;
  } catch (error) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    goodsItemInfo = {} as ItemInfo;
  }
}

export const ORDER_KEY = query('orderKey');

export const WX_APP_ID = 'wx0dbc1ae97f156c38';
export const QQ_APP_ID = '100446242';


const getRequestUrl = () => {
  return 'trpc.vap_oteam.privilege_tool.PrivilegeToolFront';
};


export const getServantName = () => {
  return 'trpc.vap_oteam.privilege_tool.PrivilegeToolFront';
};

export const getFuncName = () => {
  return 'privilegeTool';
};

export const getAppKey = () => {
  const { appKey = 'xueersi' } = goodsItemInfo;
  return appKey;
};

const buildBaseUsrAuthInfo = (accountInfo: AccountInfo, deviceInfo: DeviceInfo, data?: Record<string, any>) => {
  const { appKey = 'xueersi' } = goodsItemInfo;
  if (appKey === 'xueersi') {
    return {
      user_base_info: {
        guid: deviceInfo?.tguid,
        qua2: deviceInfo?.qua,
        phone_num: data?.phone || '',
      },
      account: {
        AccountType: accountInfo?.type,
        Openid: accountInfo?.uin,
        TokenType: TOKEN_TYPE_MAP[accountInfo?.type || 0],
        Token: accountInfo?.token,
        Appid: accountInfo?.appid,
        Qbid: accountInfo?.qbid,
      },
    };
  }
  if (appKey === 'doc') {
    return {
      user_info: {
        guid: deviceInfo?.tguid,
        qua2: deviceInfo?.qua,
        qimei36: deviceInfo?.qimei36 || '',
      },
      auth_info: {
        account_type: accountInfo?.type,
        account_id: accountInfo?.uin,
        token_type: TOKEN_TYPE_MAP[accountInfo?.type || 0],
        token: accountInfo?.token,
        appid: accountInfo?.appid,
        qbid: accountInfo?.qbid,
      },
    };
  }
  return {};
};

let urlPath = 'https://qbh5.qq.com';

if (window.location.href.indexOf('quickstarttest') > -1 || window.location.href.indexOf('test-tool') > -1) {
  urlPath = 'https://pbtest.imtt.qq.com/h5-dev';
}

export const baseFetchTool = (
  funcName: string,
  data: Record<string, any>,
  successCallback: (arg0: Camelized<any>) => void,
  errorCallback: (arg0: any) => void,
) => {
  const { accountInfo } = useAuth.storeInfo();
  const { deviceInfo } = useAuth.storeInfo();

  authSend(
    {
      servantName: getServantName(),
      funcName: `/${getRequestUrl()}/${funcName}`,
      url: urlPath,
    },
    {
      ...buildBaseUsrAuthInfo(accountInfo, deviceInfo, data),
      ...data,
    },
    {
      accountInfo: {
        qbid: accountInfo.qbid,
        uin: accountInfo.openid,
        token: accountInfo.accessToken,
        nickname: accountInfo.nickName,
        head: accountInfo.logo,
        type: accountInfo.logintype === 'qq' ? 4 : 2,
        appid: accountInfo.logintype === 'qq' ? QQ_APP_ID : WX_APP_ID,
      },
      deviceInfo: {
        guid: deviceInfo.tguid,
        qua: deviceInfo.qua,
        qimei36: deviceInfo.qimei36,
      },
    },
  )
    .then((res: any) => {
      const createRsp = camelizeKeys(res);
      console.log('🚀 ~ file: base.ts:35 ~ .then ~ createRsp:', createRsp);
      successCallback(createRsp);
      aegis.infoAll(`[pc bakend req]${JSON.stringify({
        servantName: getServantName(),
        funcName: `/${getRequestUrl()}/${funcName}`,
        url: urlPath,
        ...buildBaseUsrAuthInfo(accountInfo, deviceInfo, data),
        ...data,
        accountInfo: {
          qbid: accountInfo.qbid,
          uin: accountInfo.openid,
          token: accountInfo.accessToken,
          nickname: accountInfo.nickName,
          head: accountInfo.logo,
          type: accountInfo.logintype === 'qq' ? 4 : 2,
          appid: accountInfo.logintype === 'qq' ? QQ_APP_ID : WX_APP_ID,
        },
        deviceInfo: {
          guid: deviceInfo.tguid,
          qua: deviceInfo.qua,
          qimei36: deviceInfo.qimei36,
        },
        createRsp,
      })}`);
    })
    .catch((err: { [x: string]: any; }) => {
      console.log('🚀 ~ file: base.ts:40 ~ err:', err);
      errorCallback(err);
      aegisReportRetError(JSON.stringify({
        sign: 'pc bakend err',
        path: {
          servantName: getServantName(),
          funcName: `/${getRequestUrl()}/${funcName}`,
          url: urlPath,
        },
        auth: {
          ...buildBaseUsrAuthInfo(accountInfo, deviceInfo, data),
          ...data,
        },
        env: {
          accountInfo: {
            qbid: accountInfo.qbid,
            uin: accountInfo.openid,
            token: accountInfo.accessToken,
            nickname: accountInfo.nickName,
            head: accountInfo.logo,
            type: accountInfo.logintype === 'qq' ? 4 : 2,
            appid: accountInfo.logintype === 'qq' ? QQ_APP_ID : WX_APP_ID,
          },
          deviceInfo: {
            guid: deviceInfo.tguid,
            qua: deviceInfo.qua,
            qimei36: deviceInfo.qimei36,
          },
        },
        err,
      }));
    });
};

const getBusinessRequestUrl = () => {
  return 'trpc.mtt.tool_card.tool_card';
};


export const getBusinessServantName = () => {
  return 'trpc.mtt.tool_card.tool_card';
};

export const businessFetchTool = (
  funcName: string,
  data: Record<string, any>,
  successCallback: (arg0: Camelized<any>) => void,
  errorCallback: (arg0: any) => void,
) => {
  const { accountInfo } = useAuth.storeInfo();
  const { deviceInfo } = useAuth.storeInfo();

  authSend(
    {
      servantName: getBusinessServantName(),
      funcName: `/${getBusinessRequestUrl()}/${funcName}`,
      url: urlPath,
    },
    {
      ...buildBaseUsrAuthInfo(accountInfo, deviceInfo, data),
      ...data,
    },
    {
      accountInfo: {
        qbid: accountInfo.qbid,
        uin: accountInfo.openid,
        token: accountInfo.accessToken,
        nickname: accountInfo.nickName,
        head: accountInfo.logo,
        type: accountInfo.logintype === 'qq' ? 4 : 2,
        appid: accountInfo.logintype === 'qq' ? QQ_APP_ID : WX_APP_ID,
      },
      deviceInfo: {
        guid: deviceInfo.tguid,
        qua: deviceInfo.qua,
        qimei36: deviceInfo.qimei36,
      },
    },
  )
    .then((res: any) => {
      const createRsp = camelizeKeys(res);
      console.log('🚀 ~ file: base.ts:35 ~ .then ~ createRsp:', createRsp);
      successCallback(createRsp);
      aegis.infoAll(`[pc bakend req]${JSON.stringify({
        servantName: getBusinessServantName(),
        funcName: `/${getBusinessRequestUrl()}/${funcName}`,
        url: urlPath,
        ...buildBaseUsrAuthInfo(accountInfo, deviceInfo, data),
        ...data,
        accountInfo: {
          qbid: accountInfo.qbid,
          uin: accountInfo.openid,
          token: accountInfo.accessToken,
          nickname: accountInfo.nickName,
          head: accountInfo.logo,
          type: accountInfo.logintype === 'qq' ? 4 : 2,
          appid: accountInfo.logintype === 'qq' ? QQ_APP_ID : WX_APP_ID,
        },
        deviceInfo: {
          guid: deviceInfo.tguid,
          qua: deviceInfo.qua,
          qimei36: deviceInfo.qimei36,
        },
        createRsp,
      })}`);
    })
    .catch((err: { [x: string]: any; }) => {
      console.log('🚀 ~ file: base.ts:40 ~ err:', err);
      aegisReportRetError(JSON.stringify({
        sign: 'pc bakend err',
        path: {
          servantName: getBusinessServantName(),
          funcName: `/${getBusinessRequestUrl()}/${funcName}`,
          url: urlPath,
        },
        auth: {
          ...buildBaseUsrAuthInfo(accountInfo, deviceInfo, data),
          ...data,
        },
        env: {
          accountInfo: {
            qbid: accountInfo.qbid,
            uin: accountInfo.openid,
            token: accountInfo.accessToken,
            nickname: accountInfo.nickName,
            head: accountInfo.logo,
            type: accountInfo.logintype === 'qq' ? 4 : 2,
            appid: accountInfo.logintype === 'qq' ? QQ_APP_ID : WX_APP_ID,
          },
          deviceInfo: {
            guid: deviceInfo.tguid,
            qua: deviceInfo.qua,
            qimei36: deviceInfo.qimei36,
          },
        },
        err,
      }));
      errorCallback(err);
    });
};

